<template>
  <router-view v-if="show" />
</template>

<script>

export default {
  data () {
    return {
      show: false
    }
  },
  created () {
    this.$eventBus.$emit('showLoading', true)
    if (this.hasAnyPermission('PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT')) {
      this.show = true
      this.$eventBus.$emit('showLoading', false)
    } else {
      window.location.href = this.$DjangoBaseUrl('/talent-pool/')
    }
  },
  methods: {

  }
}
</script>
